import { Button, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { IInvestmentOrder } from '~/@api/generated-api-types/global.types'
import { InvestmentCard } from './InvestmentCard'

type Props = {
  investments: IInvestmentOrder[] | null
}

export const InvestmentsTab = ({ investments }: Props) => {
  const navigate = useNavigate()

  const navigateToOpportunities = () => navigate('/investor/opportunities')

  return (
    investments &&
    (investments.length > 0 ? (
      <Stack className="px-6 pt-8">
        <Typography className="text-base font-bold text-zBlack200">
          Moje investície
        </Typography>

        <Stack className="gap-[15px] pt-4">
          {investments.map((invst) => (
            <InvestmentCard
              key={`investment-tab-${invst.id}`}
              investment={invst}
            />
          ))}
        </Stack>
      </Stack>
    ) : (
      <Stack className="px-6 pt-8">
        <Typography className="text-3d font-medium text-zGrey400 text-center">
          Nemáte žiadne investície.
        </Typography>
        <Button
          variant="contained"
          className="w-fit h-[56px] self-center px-10 mt-8"
          onClick={navigateToOpportunities}>
          <Typography className="text-3d font-medium text-zWhite200">
            Prvá Investícia
          </Typography>
        </Button>
      </Stack>
    ))
  )
}
